import axios from "axios";
// import { toast } from "react-toastify";
import defaultErrorHandler from "api/global/default-error-handler";

import settings from "utils/settings";
import {toast} from "react-toastify";

const { apiUrl } = settings;

export const ORDER_EXPORT_LOADING = "ORDER_EXPORT_CHARGES_LOADING";
export const ORDER_EXPORT_ERROR = "ORDER_EXPORT_ERROR";
export const ORDER_EXPORT_GET_LAYOUTS = "ORDER_EXPORT_GET_LAYOUTS";
export const ORDER_EXPORT_SET_LAYOUTS = "ORDER_EXPORT_SET_LAYOUTS";
export const ORDER_EXPORT_GET_LAYOUT_BY_ID = "ORDER_EXPORT_GET_LAYOUT_BY_ID";
export const ORDER_EXPORT_GET_FIELDS = "ORDER_EXPORT_GET_FIELDS";
export const ORDER_EXPORT_DELETE_LAYOUT_BY_ID = "ORDER_EXPORT_DELETE_LAYOUT_BY_ID";
export const ORDER_EXPORT_UPDATE_LAYOUT_BY_ID = "ORDER_EXPORT_UPDATE_LAYOUT_BY_ID";

export const setLoading = (status) => ({
    type: ORDER_EXPORT_LOADING,
    payload: status
});

export const getOrderExportLayoutById = (id = false) => dispatch => {
    if (!id) {
        dispatch({
            type: ORDER_EXPORT_GET_LAYOUT_BY_ID,
            payload: {}
        });
        return;
    }
    dispatch(setLoading(true));
    axios.get(`${apiUrl}orderExport/layouts/${id}`)
        .then(response => {
            dispatch({
                type: ORDER_EXPORT_GET_LAYOUT_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, ORDER_EXPORT_ERROR));
        });
};

export const getOrderExportLayoutFields = (reset = false) => dispatch => {
    if (reset === true) {
        dispatch({
            type: ORDER_EXPORT_GET_FIELDS,
            payload: []
        });
        return;
    }
    dispatch(setLoading(true));
    axios.get(`${apiUrl}orderExport/fields`)
        .then(response => {
            dispatch({
                type: ORDER_EXPORT_GET_FIELDS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, ORDER_EXPORT_ERROR));
        });
};

export const getOrderExportLayouts = (reset = false) => dispatch => {
    if (reset === true) {
        dispatch({
            type: ORDER_EXPORT_GET_LAYOUTS,
            payload: []
        });
        return;
    }
    dispatch(setLoading(true));
    axios.get(`${apiUrl}orderExport/layouts`)
        .then(response => {
            dispatch({
                type: ORDER_EXPORT_GET_LAYOUTS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, ORDER_EXPORT_ERROR));
        });
};

export const createOrderExportLayout = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    axios.post(`${apiUrl}orderExport/layouts`, data)
        .then(response => {
            callback(true);
            toast("Order layout successfully created", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch({
                type: ORDER_EXPORT_SET_LAYOUTS,
                payload: response.data
            });
        })
        .catch(error => {
            callback(false);
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, ORDER_EXPORT_ERROR));
        });
};

export const updateOrderExportLayout = (id, data, callback) => dispatch => {
    dispatch(setLoading(true));
    axios.put(`${apiUrl}orderExport/layouts/${id}`, data)
        .then(response => {
            callback(true);
            toast("Order layout successfully updated", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch({
                type: ORDER_EXPORT_UPDATE_LAYOUT_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            callback(false);
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, ORDER_EXPORT_ERROR));
        });
};

export const deleteOrderExportLayout = (id) => dispatch => {
    dispatch(setLoading(true));
    axios.delete(`${apiUrl}orderExport/layouts/${id}`)
        .then(response => {
            toast("Order layout successfully deleted", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch({
                type: ORDER_EXPORT_DELETE_LAYOUT_BY_ID,
                payload: { id }
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, ORDER_EXPORT_ERROR));
        });
};
